import { Show } from 'solid-js'
import AIFansLoading from '../AIFansLoading'

interface Props {
  onSubscribe: () => void
  subscribing: boolean
  modelName?: string
  creatorName?: string
  backgroundImage?: string
}

const SubscribeToUnlock = (props: Props) => {
  return (
    <div
      class="subscribe-section flex w-full items-start justify-center"
      style={{ padding: '32px 0' }}
    >
      <div
        class="subscribe-card relative w-full overflow-hidden p-[56px_24px] text-center sm:p-[80px_40px]"
        style={{
          'border-radius': '20px',
          border: '1px solid rgba(138, 43, 226, 0.3)',
        }}
      >
        {/* Blurred creator-image background */}
        <Show when={props.backgroundImage}>
          <img
            src={props.backgroundImage}
            alt=""
            class="subscribe-bg absolute inset-0 z-0 h-full w-full"
            style={{ 'object-fit': 'cover', filter: 'blur(20px) brightness(0.35)' }}
          />
        </Show>

        {/* Dark gradient overlay */}
        <div
          class="subscribe-overlay absolute inset-0 z-0"
          style={{
            background: 'linear-gradient(180deg, rgba(11, 11, 15, 0.4), rgba(11, 11, 15, 0.85))',
          }}
        />

        {/* Content */}
        <div class="subscribe-content relative z-[1]">
          <h2
            class="flex items-center justify-center gap-2 whitespace-nowrap font-bebas font-bold text-white"
            style={{
              'letter-spacing': '1px',
              'font-size': 'clamp(32px, 4vw, 56px)',
              'margin-bottom': '20px',
            }}
          >
            <span style={{ color: '#ffc107' }}>🏆</span> Subscribe To Unlock!
          </h2>

          <p
            style={{
              color: 'var(--cf-muted)',
              'font-size': '15px',
              'line-height': '22.5px',
              'margin-bottom': '30px',
            }}
          >
            <Show
              when={props.creatorName}
              fallback={<>Enjoy full access to {props.modelName}.</>}
            >
              Enjoy full access to {props.modelName} and exclusive content from {props.creatorName}.
            </Show>
          </p>

          <button
            class="inline-flex items-center justify-center font-rajdhani uppercase text-white"
            style={{
              height: '48px',
              padding: '0 32px',
              border: 'none',
              'border-radius': '999px',
              'font-weight': 800,
              'font-size': '14px',
              'letter-spacing': '0.8px',
              background: 'linear-gradient(135deg, #8a2be2 0%, #6a1fb8 50%, #8a2be2 100%)',
              'box-shadow': '0 6px 24px rgba(138, 43, 226, 0.45)',
            }}
            onClick={props.onSubscribe}
          >
            <Show when={!props.subscribing} fallback={<AIFansLoading show={true} plain={true} />}>
              Subscribe Now
            </Show>
          </button>
        </div>
      </div>
    </div>
  )
}

export default SubscribeToUnlock
